var theme = require('./theme')
var flatten = require('./flatten')

module.exports = theme('fr_FR', flatten(require('./source/fr_FR')))
